export class ConsolidatedOrder {
  constructor({
    id,
    merchantId,
    merchantName,
    status = 'pending',
    storeOrderIds = [],
    items = [],
    total = 0,
    createdBy,
    createdAt,
    orderedAt = null,
    receivedAt = null,
  }) {
    this.id = id;
    this.merchantId = merchantId;
    this.merchantName = merchantName;
    this.status = status;
    this.storeOrderIds = storeOrderIds;
    this.items = items;
    this.total = total;
    this.createdBy = createdBy;
    this.createdAt = createdAt;
    this.orderedAt = orderedAt;
    this.receivedAt = receivedAt;
  }

  toJson() {
    return {
      merchantId: this.merchantId,
      merchantName: this.merchantName,
      status: this.status,
      storeOrderIds: this.storeOrderIds,
      items: this.items,
      total: this.total,
      createdBy: this.createdBy,
      createdAt: this.createdAt,
      orderedAt: this.orderedAt,
      receivedAt: this.receivedAt,
    };
  }

  static fromFirebase(doc) {
    const data = doc.data();
    return new ConsolidatedOrder({
      id: doc.id,
      merchantId: data.merchantId,
      merchantName: data.merchantName,
      status: data.status || 'pending',
      storeOrderIds: data.storeOrderIds || [],
      items: data.items || [],
      total: data.total || 0,
      createdBy: data.createdBy,
      createdAt: data.createdAt,
      orderedAt: data.orderedAt || null,
      receivedAt: data.receivedAt || null,
    });
  }

  static aggregateItems(orders) {
    const itemMap = new Map();

    orders.forEach(order => {
      order.items.forEach(item => {
        const key = item.productId;
        if (itemMap.has(key)) {
          const existing = itemMap.get(key);
          existing.totalQuantity += item.quantity;
          existing.total = existing.totalQuantity * existing.unitPrice;
        } else {
          itemMap.set(key, {
            productId: item.productId,
            name: item.name,
            totalQuantity: item.quantity,
            unitPrice: item.unitPrice,
            total: item.quantity * item.unitPrice,
          });
        }
      });
    });

    return Array.from(itemMap.values());
  }
}
